import { AxiosError } from 'axios';
import useSWRMutation from 'swr/mutation';

import { camelizeKeys } from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  unauthenticatedFetchers,
} from '../lib';

export type EmailValidationRequestT = {
  email: string;
};

export type RawEmailValidationResponseT = {
  email_apply_eligible?: boolean;
  secured?: boolean;
};

export type EmailValidationResponseT = {
  emailApplyEligible?: boolean;
  secured?: boolean;
};

export const useValidateEmail = () => {
  const {
    error,
    isMutating,
    reset,
    trigger: validateEmail,
  } = useSWRMutation<
    EmailValidationResponseT,
    AxiosError,
    string,
    EmailValidationRequestT
  >(
    apiEndpoints.apply.v2.existingEmail,
    async (url, { arg }) => {
      const data = await unauthenticatedFetchers.post<
        EmailValidationRequestT,
        RawEmailValidationResponseT
      >(url, { arg });

      return camelizeKeys<typeof data, EmailValidationResponseT>(data);
    },
    { throwOnError: false },
  );

  return {
    error,
    isMutating,
    reset,
    validateEmail,
  };
};
